import { AnalyticsTypes } from '../../middleware/google-analytics';
import { APPOINTMENT_INFO_GA_CATEGORY } from '../pages/AppointmentInfo/constants';

export const InsuranceCardLightBoxActions = {
    OPEN: '@@iclb/OPEN',
    CLOSE: '@@iclb/CLOSE',
    SWITCH: '@@iclb/SWITCH',
};

export const openImagePreview = () => ({
    type: InsuranceCardLightBoxActions.OPEN,
    payload: true,
    meta: {
        analytics: [
            {
                type: AnalyticsTypes.TrackEvent,
                category: APPOINTMENT_INFO_GA_CATEGORY,
                action: 'Open Image Preview',
            },
            {
                type: AnalyticsTypes.TrackEvent,
                category: APPOINTMENT_INFO_GA_CATEGORY,
                action: 'Clicked Insurance Card Thumbnail',
            },
        ],
    },
});

export const closeImagePreview = () => ({
    type: InsuranceCardLightBoxActions.CLOSE,
    payload: false,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: 'Close Image Preview',
        },
    },
});

export const trackSwitchImageInPreview = () => ({
    type: InsuranceCardLightBoxActions.SWITCH,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: 'Switch Image in Preview',
        },
    },
});
